import { jsx as _jsx } from "react/jsx-runtime";
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import MakeLogo from './MakeLogo';
export default function MakeCard() {
    const { t: texts } = useLocaleKeys('integrations.availableApps.make');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('make');
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "make-card",
        icon: /*#__PURE__*/ _jsx(MakeLogo, {}),
        title: texts.title(),
        subTitle: texts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            onClick: showCopyAPIKeyModal,
            testId: "make-card-connect",
            children: sharedTexts.connectButton()
        })
    });
}
